export const decodeJwtPayload = (token: string): object => {
  const [, payloadBase64Url] = token.split(".");
  const payloadBase64 = payloadBase64Url.replace(/-/g, "+").replace(/_/g, "/");
  const decodedPayload = atob(payloadBase64);

  return JSON.parse(decodedPayload);
};
